module.exports = __webpack_public_path__ + "img/sample_bg_01.d966abf3.jpg";